module.exports = "/images/vendor/flag-icon-css/flags/1x1/gb-sct.svg?31ef8bcf9416bbd5b8c6ef29d1411e5f";